import { forwardRef } from 'react';
import { TextField, type TextFieldProps } from '@mui/material';

/**
 * RwField — the DS text Field (rw-ds.css `.rw-field` + MUI-BRIDGE §Field).
 *
 * Thin pass-through over MUI `TextField`; the DS appearance (static label ABOVE
 * the control, notch-free outlined shell, token border/focus/error, DS helper
 * text) is applied globally in `themeOptions.ts`, so this stays a drop-in for
 * TextField's full controlled API (value/onChange/error/helperText/select/
 * multiline/adornments/Formik). Exists so pages consume the DS name and never
 * import raw `@mui` fields.
 *
 * Use `label` (rendered above), `helperText`, `error`, `required`, `select`,
 * `multiline` as with TextField.
 */
const RwField = forwardRef<HTMLDivElement, TextFieldProps>(function RwField(props, ref) {
  return <TextField ref={ref} {...props} />;
});

export default RwField;
// Named alias — see RwButton.tsx for why this stays alongside the default export.
export { RwField };
